import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import _ from 'lodash';
import moment from 'moment';

export function AutoEmailRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.AutoEmail', {
		url: '/autoEmail',
		controllerAs: 'vm',
		controller: AutoEmailCtrl,
		templateUrl: '/ng/hub/Email/Auto/AutoEmailCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Email/Auto/AutoEmailCtrl.css'),
			$title: () => 'Add/Edit Email Alert',
		},
	});
}

export class AutoEmailCtrl {
	constructor(Api, Cfg, modal, Identity, $scope, Rec, TimeZone) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Cfg = Cfg;
		this.modal = modal;
		this.Identity = Identity;
		this.Rec = Rec;
		this.TimeZone = TimeZone;
		// setup
		this.recipients = this.Rec && this.Rec.recipients ? JSON.parse(this.Rec.recipients) : [];
		this.search = { taxonomies: {} };
		this.showSubscribeOption = true;

		let userTz;
		this.initialize();
		if (this.isEdit) {
			this.validate();
			// get the user's timezone from the database
			userTz = this.Rec.user_tz;
		} else {
			// guess the user's timezone
			userTz = TimeZone.getUserTimezone().id;
		}
		// populate the timezone value in the dropdown
		this.userTz = userTz || 'America/New_York';
		this.fineTunerClosed = true;
		this.addWatches($scope);
	}

	addWatches($scope) {
		$scope.$watch('vm.selectedRecipients', (newVal, oldVal) => {
			if (oldVal == newVal) {
				return null;
			}
			this.validateRecipients();
		});
	}

	// set property values
	initialize() {
		this.isEdit = _.has(this.Rec, 'id') ? true : false;
		this.autoAlertSetting = this.Cfg.readAsBool('Features.only_admin_autoalert_subscriptions');
		if (this.autoAlertSetting && !this.Identity.isAccountManager()) {
			this.showSubscribeOption = false;
		}
		this.errors = {};
		// components
		this.setSearchCriteriaProps();
		this.getSuggestedRecipients = this.getSuggestedRecipients.bind(this);
		this.selectedRecipients = [];
		this.initTimeAndFrequency();
		this.subject = _.get(this.Rec, 'subject', '');
		this.isPublic = Boolean(Number(_.get(this.Rec, 'is_public', 0)));
		this.isLoginRequired = _.get(this.Rec, 'private_link', 0) === 'logged_in' ? true : false;
		if (this.isEdit) {
			this.lookupRecipients(this.recipients);
		}
	}

	initTimeAndFrequency() {
		this.initTime();
		this.initFrequency();
		if (this.freq == this.freqImmediate) {
			this.setToImmediate();
		}
	}

	initTime() {
		this.freqImmediate = 'immediate';
		this.freqTimeDefault = '08:30 am';

		let freqTime = _.get(this.Rec, 'send_time');
		if (!freqTime && !this.isEdit) {
			freqTime = this.freqTimeDefault;
		}

		let Mom = moment(freqTime);
		this.freqTime = Mom.isValid() ? Mom.format('h:mm a') : 'Invalid';
	}

	initFrequency() {
		this.freqOptions = [
			{ text: 'Immediately', value: this.freqImmediate },
			{ text: 'Weekdays', value: 'weekdays' },
			{ text: 'Every day', value: 'every' },
			{ text: 'Mondays', value: 'mon' },
			{ text: 'Tuesdays', value: 'tue' },
			{ text: 'Wednesdays', value: 'wed' },
			{ text: 'Thursdays', value: 'thu' },
			{ text: 'Fridays', value: 'fri' },
			{ text: 'M/W/F', value: 'mwf' },
			{ text: 'Tu/Th', value: 'tt' },
		];

		const def = 'weekdays';
		this.freq = def;
		let freq = _.get(this.Rec, 'send_frequency') || def;
		this.freqOptions.forEach(option => {
			if (option.value == freq) {
				this.freq = freq;
				return true;
			}
		});
	}

	setSearchCriteriaProps() {
		if (!this.isEdit) {
			return null;
		}

		this.search.term = _.get(this.Rec, 'search_term') || null;
		let val = _.get(this.Rec, 'search_tags');
		if (val) {
			this.search.tags = val.split(',');
		}
		val = _.get(this.Rec, 'search_categories');
		if (val) {
			this.search.categories = val.split(',');
		}
		val = _.get(this.Rec, 'search_publishers');
		if (val) {
			this.search.publishers = _.uniq(val.split(',')).map(n => {
				return parseInt(n);
			});
		}
		val = _.get(this.Rec, 'search_domains');
		if (val) {
			this.search.domains = val.split(',');
		}
		val = _.get(this.Rec, 'search_client_intel', null);
		if (val !== null) {
			this.search.clientIntel = parseInt(val) ? true : false;
		}
		val = _.get(this.Rec, 'search_untagged', null);
		if (val !== null) {
			this.search.untagged = parseInt(val) ? true : false;
		}
		val = _.get(this.Rec, 'search_tags_all', null);
		if (val !== null) {
			this.search.tagsAll = parseInt(val) ? true : false;
		}
		val = _.get(this.Rec, 'search_approval_status', null);
		if (val) {
			this.search.approvalStatus = val;
		}
		val = _.get(this.Rec, 'search_classifications');
		if (val) {
			this.search.classifications = val.split(',');
		}
		this.search.dateStart = this.Rec.last_run || this.Rec.created_at;

		if (this.Rec.filters && this.Rec.filters.taxonomies) {
			this.search.taxonomies = this.Rec.filters.taxonomies;
		}

		return true;
	}

	hasError(type) {
		if (this.getError(type)) {
			return true;
		}
		return false;
	}

	getError(type) {
		let ret = '';

		_.forOwn(this.errors, (val, key, object) => {
			if (key == type) {
				ret = val;
				return false;
			}
			if (!type && val) {
				ret = val;
				return false;
			}
		});

		return ret;
	}

	setError(type, msg) {
		this.errors[type] = msg;
	}

	clearError(type) {
		this.setError(type, '');
	}

	updateDistList(editedListId, editedListName, editedListNumMembers) {
		this.selectedRecipients.some(recipient => {
			if (recipient.type == 'group' && recipient.id == editedListId) {
				recipient.$label = `${editedListName} (${editedListNumMembers})`;
				return true;
			}
			return false;
		});
	}

	/**
	 * Removes an item from the list of recipients (used by EmailAddressBook when items removed)
	 * @param itemObj Object  e.g., {checked: false, count: 6, label: "Member", role: "member"}
	 * @param item String  e.g., "role:member", "hello@example.com", "gid:43"
	 */
	removeRecipientItem(itemObj, item) {
		if (this.recipients.length == 0) {
			return;
		}
		this.recipients = this.recipients.filter(recip => recip != item);
		this.lookupRecipients(this.recipients);
	}

	addRecipientItem(itemObj, item) {
		this.recipients.push(item);
		this.lookupRecipients(this.recipients);
	}

	openAddressBook() {
		// get `this.recipients` based on the current items in the typeahead
		this.recipients = this.parseRecipientsForSave(this.selectedRecipients);
		const updateFunctions = {
			removeRecipientItem: this.removeRecipientItem.bind(this),
			addRecipientItem: this.addRecipientItem.bind(this),
			updateDistList: this.updateDistList.bind(this),
		};
		this.modal.state('hub.loggedin.EmailAddressBook', {
			heading: 'Address Book',
			locals: { recipients: this.recipients, ...updateFunctions },
			width: 1000,
			height: 'full',
		});
	}

	/**
	 * The auto_emails record provide `recipients` like this: [“hello@example.com”,“gid:1",“role:member”,“role:intel leader”]
	 * This function sends that information to /emails/lookup_recipients, which returns more information about each item.
	 * The function then formats the information for use by the typeahead.
	 * @param recipients
	 */
	lookupRecipients(recipients) {
		if (!recipients.length) {
			this.selectedRecipients = [];
			return null;
		}
		const commaDelimitedRecipients = recipients.join(',');

		this.Api.get('/emails/lookup_recipients', { recipients: commaDelimitedRecipients }).then(recipients => {
			this.selectedRecipients = recipients.map(recip => {
				if (recip.type == 'user') {
					recip.$search = recip.email;
					recip.$label = recip.email;
					recip.icon = 'user';
				} else if (recip.type == 'role') {
					recip.$label = 'Role: ' + recip.label;
					recip.icon = 'portfolio';
				} else if (recip.type == 'group') {
					recip.$label = `List: ${recip.name} (${recip.num_members})`;
					recip.gid = recip.id;
					recip.icon = 'folder2';
				} else if (recip.type === 'division') {
					recip.$label = `Division: ${recip.label}`;
					recip.icon = 'division';
				} else if (recip.type === 'organization') {
					recip.$label = `Organization: ${recip.label}`;
					recip.icon = 'organization';
				}

				return recip;
			});
		});
	}

	getSuggestedRecipients(term) {
		return new Promise((resolve, reject) => {
			this.Api.get('/emails/suggest_recipients', { term, type: 'auto' }).then(suggestions => {
				suggestions.forEach(sugg => {
					// recipient.$search = recipient.label;
					sugg.$label = sugg.label;
				});

				resolve(suggestions);
			});
		});
	}

	/**
	 * Turns `recipients` into the format required by auto_emails.recipients
	 * @param recipients Array  An array of objects like those returned from /v2/emails/suggest_recipients
	 *
	 * @returns {Array} e.g., [“hello@example.com”,“gid:1",“role:member”,“role:intel leader”]
	 */
	parseRecipientsForSave(recipients) {
		if (!recipients || !Array.isArray(recipients)) {
			return [];
		}

		// turns `recipients` into [“aaron@sharpr.com”,“gid:1",“role:member”,“role:intel leader”]
		const parsedRecipients = recipients.map(recip => {
			switch (recip.icon) {
				// role
				case 'portfolio':
					return `role:${recip.role}`;
				// list
				case 'folder2':
					return `gid:${recip.gid}`;
				// user
				case 'user':
					return recip.email;
				case 'division':
					return `division:${recip.label}`;
				case 'organization':
					return `organization:${recip.label}`;
				default:
					break;
			}
			// this is an email address that isn't yet a sharpr user
			if (recip.$new == true) {
				return recip.name;
			}
		});

		return parsedRecipients;
	}

	recipientsChanged() {
		this.validateRecipients();
	}

	validateRecipients() {
		if (!Array.isArray(this.selectedRecipients) || !this.parseRecipientsForSave(this.selectedRecipients).length) {
			this.setError('recips', 'At least one recipient is required');
			return false;
		}

		this.clearError('recips');
		return true;
	}

	cancel() {
		this.modal.closeTop();
	}

	save() {
		if (!this.validate()) {
			return false;
		}

		this.isSaving = true;
		let data = this.getSaveData();

		let verb = this.isEdit ? 'patch' : 'post';
		let url = this.isEdit ? '/v2/auto_emails/' + this.Rec.id : '/v2/auto_emails';
		this.Api.request(verb, url, data).then(resp => {
			this.isSaving = false;
			if (resp.status < 200 || resp.status > 299) {
				this.modal.alert({ text: 'Unexpected error' });
				return false;
			}

			this.search = {};

			// IMPORTANT: In order for this.modal.resolveByTitle to succeed the "title" created here must exactly match
			// the one created in UserPreferencesAutoEmailsCtrl.editAutoEmail(). If they don't match exactly, resolveByTitle
			// will skip it.
			let title = (this.isEdit ? 'Edit' : 'Create') + ' an Automated Alert';
			return this.modal.resolveByTitle(title, 'Saved');
		});
	}

	validate() {
		let valid = true;

		// not shortcutting these in one if to ensure that all validation is performed
		if (!this.validateSubject()) {
			valid = false;
		}
		if (!this.validateRecipients()) {
			valid = false;
		}

		return valid;
	}

	validateSubject() {
		this.subject = this.subject.trim(); // NOTE: Trimming to prevent all white space values.

		if (!this.subject) {
			this.setError('subject', 'Subject is required');
			return false;
		}

		this.clearError('subject');
		return true;
	}

	getSaveData() {
		let data = {
			subject: this.subject,
			send_frequency: this.freq,
			send_time: moment(this.freqTime).format('HHmm00'),
			recipients: JSON.stringify(this.parseRecipientsForSave(this.selectedRecipients)),
			user_tz: this.userTz,
			search_limit: 30,
			search_term: this.search.term || '',
			search_clients: this.Identity.currentClient().id.toString(),
			is_public: this.isPublic,
		};

		if (this.isLoginRequired) data.private_link = 'logged_in';

		if (this.isEdit) {
			let nullableData = {
				search_tags: '',
				search_categories: '',
				search_publishers: '',
				search_domains: '',
				search_classifications: '',
				search_approval_status: '',
				search_client_intel: 99,
				search_untagged: 99,
				search_tags_all: 0,
			};

			data = { ...data, ...nullableData };
		}

		if (_.get(this.search, 'tags', []).length) {
			data['search_tags'] = this.search.tags.join(',');
		}
		if (_.get(this.search, 'categories', []).length) {
			data['search_categories'] = this.search.categories.join(',');
		}
		if (_.get(this.search, 'publishers', []).length) {
			data['search_publishers'] = this.search.publishers.join(',');
		}
		if (_.get(this.search, 'domains', []).length) {
			data['search_domains'] = this.search.domains.join(',');
		}
		if (_.get(this.search, 'classifications', []).length) {
			data['search_classifications'] = this.search.classifications.join(',');
		}
		if (typeof this.search.clientIntel !== 'undefined') {
			data['search_client_intel'] = this.search.clientIntel ? '1' : '0';
		}
		if (typeof this.search.untagged !== 'undefined') {
			data['search_untagged'] = this.search.untagged ? '1' : '0';
		}
		if (typeof this.search.tagsAll !== 'undefined') {
			data['search_tags_all'] = this.search.tagsAll ? '1' : '0';
		}
		if (this.search.approvalStatus) {
			data['search_approval_status'] = this.search.approvalStatus;
		}

		data.filters = { taxonomies: this.search.taxonomies };

		return data;
	}

	handleFreqChange(evt) {
		if (evt.srcElement.value == this.freqImmediate) {
			this.setToImmediate();
		}
	}

	setToImmediate() {
		this.freqTime = '';
		this.freqTimePlaceholder = '';
	}
}
